import { Component, HostListener, OnInit } from '@angular/core';
import { ClientService } from 'app/services/client-service';

@Component({
    selector: 'app-pop-up-legaliboo',
    templateUrl: './pop-up-legaliboo.component.html',
    styleUrls: ['./pop-up-legaliboo.component.scss']
})
export class PopUpLegaliboo implements OnInit {

    show: Boolean = false;

    constructor(
        private clientService: ClientService
    ) { }

    ngOnInit() {

        this.clientService.observerLegalibooPopUp().subscribe((result: any) => {
            if (result !== 100) {
                this.show = true;
            }
        });

    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event): void {
        if (event.target.innerHTML.includes('loading-container-cont wow fadeInUp')) {
            // clicked outside => close modal
            this.show = false;
        }
    }

    closeModal() {
        this.show = false;
    }

}
